import { guid } from "traveldesk-ui"

export default class TourExternalLinkModel {
    public static Create(obj: TourExternalLinkModel) {
        return Object.assign(new TourExternalLinkModel(), obj, {
            guid: guid()
        })
    }
    id: number = 0
    guid: string = guid()
    title: string = ''
    url: string = ''
}